
import { RevButton } from '@ds/components/Button'
import { RevButtonRounded } from '@ds/components/ButtonRounded'
import { openModal } from '@ds/components/ModalBase'
import { RevPopover } from '@ds/components/Popover'
import { RevSkeleton } from '@ds/components/Skeleton'
import { RevTooltip } from '@ds/components/Tooltip'
import { IconInfo } from '@ds/icons/IconInfo'
import { IconSwap } from '@ds/icons/IconSwap'

import SwapModal from '@buyback/customer/swap/components/Modal'
import { MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { trackSwap } from '@tracking/events'

import { SWAP_ERROR, SWAP_LOADING } from './SwapBlock.constants'
import translations from './SwapBlock.translations'

export default {
  components: {
    RevButton,
    RevButtonRounded,
    FormattedMessage,
    IconSwap,
    RevPopover,
    RevTooltip,
    RevSkeleton,
    SwapModal,
  },

  props: {
    price: {
      type: Object,
      required: true,
    },
    model: {
      type: String,
      required: true,
    },
    swapListings: {
      type: Array,
      default: () => [],
    },
    swapOffer: {
      type: Object,
      required: true,
    },
    swapRedirection: {
      type: String,
      default: () => 'none',
    },
    shipping: {
      type: [Object, String],
      required: true,
    },
    gradeId: {
      type: Number,
      default: () => null,
    },
    productCategory: {
      type: String,
      default: () => '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
    trackingLabel: {
      type: String,
      required: true,
    },
    modalName: {
      type: String,
      required: true,
      validator: (value) =>
        [
          MODAL_NAMES.BUYBACK.SWAP_PRODUCT,
          MODAL_NAMES.BUYBACK.SWAP_CART,
          MODAL_NAMES.BUYBACK.SWAP_CHECKOUT_SUMMARY,
        ].includes(value),
    },
    swapStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      swapPayload: {},
      swapRedirectionData: this.swapRedirection,
    }
  },
  computed: {
    translations: () => translations,
    IconInfo: () => IconInfo,

    hasSwapOffer() {
      return this.swapOffer && this.swapOffer.isOffer
    },

    swapOfferTitle() {
      return !this.hasSwapOffer ? '' : this.swapOffer.model
    },

    isPriceForFree() {
      const priceAmount = parseInt(this.swapOfferPrice.split(' ')[0], 10)

      return priceAmount === 0
    },

    swapOfferPrice() {
      return this.swapOffer.price ?? ''
    },

    hasButtonMargins() {
      return !this.compact && !this.hasFailed
    },

    isLoading() {
      return this.swapStatus === SWAP_LOADING
    },

    hasFailed() {
      return this.swapStatus === SWAP_ERROR
    },
  },
  watch: {
    swapRedirection(newSwapRedirection) {
      // watch it
      this.swapRedirectionData = newSwapRedirection
    },
  },
  methods: {
    handleSwap() {
      trackSwap({
        label: this.trackingLabel,
        category: this.productCategory,
      })
      this.swapPayload = {
        listing_id: this.gradeId,
      }
      openModal(this.modalName)
    },
  },
}
